import { ICorpusTask } from '../../models/ICorpusTask';

export function getCorpusTitleFromTask(task: ICorpusTask) {
    const { data } = task;

    let dataObj;

    try {
        dataObj = JSON.parse(data);
    } catch (error) {

    }

    return getCorpusTitle(dataObj?.code);
}

function getCorpusTitle(text) {
    let title;
    const titleRegex = /title:\s*`([^`]*)`/;
    const match = text.match(titleRegex);
    if (match && match[1]) {
        title = match[1];
    }
    return title || 'Corpus Information';
}